export default "__VITE_ASSET__73f7667b__"